<template>
  <div :class="dropAreaClasses">
    <div
      class="
        sf-grid sf-pad-3 sf-layer-border sf-border-snow sf-dropzone
        tw-rounded-lg
        tw-flex
        tw-flex-col
        tw-items-center
        tw-justify-center
        tw-gap-3
      "
    >
      <i
        class="fa fa-cloud-upload tw-text-xl tw-text-sf-gray-darker"
        :class="dropAreaTextClasses"
      />
      <div class="tw-flex tw-flex-col tw-items-center tw-justify-center">
        <span
          v-dompurify-html="
            I18n.t('components.document.documents_uploader_dropzone_new_file', {
              href: `<a>${I18n.t('components.document.browse')}</a>`,
            })
          "
          class="tw-text-center tw-inline-block tw-leading-[18px]"
          :class="dropAreaTextClasses"
        />
        <span
          class="tw-inline-block tw-leading-[18px]"
          :class="dropAreaTextClasses"
        >
          <span>
            {{ I18n.t('components.document.documents_uploader_dropzone_or') }}
          </span>
          <a @click.stop="handleSelectExistingFileClick">
            {{
              I18n.t(
                'components.document.documents_uploader_dropzone_select_existing_file'
              )
            }}
          </a>
        </span>
        <span v-if="showAttachExternalLink">
          {{ I18n.t('components.document.documents_uploader_dropzone_or') }}
          <a @click.stop="handleAttachExternalLinkClick">
            {{
              I18n.t(
                'components.document.documents_uploader_dropzone_attach_external_link'
              )
            }}
          </a>
        </span>
      </div>
      <slot name="post-script"></slot>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import useI18n from '@app/shared/vue/composables/use-I18n'

interface Props {
  disabled?: boolean
  variant?: 'default' | 'seamless'
  showAttachExternalLink?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  variant: 'default',
})

const emit =
  defineEmits<{
    'attach-external-link': []
    'select-existing': []
  }>()

const I18n = useI18n()

const dropAreaClasses = computed(() => {
  return {
    'sf-pad-l-3': props.variant === 'default',
    'sf-pad-r-3 ': props.variant === 'default',
  }
})

const dropAreaTextClasses = computed(() => {
  return {
    'tw-opacity-35': props.disabled,
    'hover:tw-cursor-not-allowed': props.disabled,
  }
})

function handleSelectExistingFileClick() {
  emit('select-existing')
}

function handleAttachExternalLinkClick() {
  emit('attach-external-link')
}
</script>
